import modelsResolver from 'utils/api/models/utils/modelsResolver';
import { SingleTroubleTicketingSelectOption } from './singleSelectOption';

export type TroubleTicketingSelectOptions = {
	label?: string; // label name
	_elements: any;
	elements: SingleTroubleTicketingSelectOption[]; // select options
};

const model = {
	label: 'label',
	_elements: ['elements', []],
	elements: (model: TroubleTicketingSelectOptions) =>
		model._elements.map((element: any) => modelsResolver(element, 'singleSelectOption')),
};

export default model;
